
import { Retriever, IState } from "../../../../../common";
import { SportModel } from "../../..";
import { SportBFFQueryFactory, SportApiQueryFactory } from "../../../queries";
import { SportsBaseRetriever } from "..";

export class SportsRetriever extends Retriever<SportModel> {

    private readonly baseRetriever: SportsBaseRetriever;
    private readonly sportBffQueryFactory: SportBFFQueryFactory;
    private readonly sportApiQueryFactory: SportApiQueryFactory;

    constructor (baseRetriever: SportsBaseRetriever, sportBffQueryFactory: SportBFFQueryFactory, sportApiQueryFactory: SportApiQueryFactory) {
        super();
        this.baseRetriever = baseRetriever;
        this.sportBffQueryFactory = sportBffQueryFactory;
        this.sportApiQueryFactory = sportApiQueryFactory;
    }

    async activate(state: IState<SportModel>) {
        this.baseRetriever.activate();
        await this.baseRetriever.refresh(state, this.sportBffQueryFactory, this.sportApiQueryFactory);
    }

    deactivate() {
        this.baseRetriever.deactivate();
    }
}